export const SINGLE_USER_LICENSE_CODE = 1004;
export const ADD_TO_BASKET_LOCALSTORAGE_KEY = "addToBasketOnLoginReturn";
